import React from 'react';
import { IFRAME, TransparencyCatalogSearchModal } from './TransparencyCatalogModal..styles';

interface Props {
    isOpen: boolean;
}

const TransparencyCatalogModal: React.FC<Props> = ({ isOpen }) => {
    return (
        <TransparencyCatalogSearchModal open={isOpen}>
            <IFRAME title="search" src="https://staging.transparencycatalog.com/search"></IFRAME>
        </TransparencyCatalogSearchModal>
    );
};

export default TransparencyCatalogModal;
